module.exports = __webpack_public_path__ + "static/media/BroomeAdvertiser-devicecomp-min@2x.222b5162.webp";